import Donate from '@/core/components/Donate/Donate';

export default Donate;
